(function (root) {
  // Coffee product pages: a failed variant-details request must not reload the page (a reload drops the
  // chosen purchase mode, interval and quantity). The selections stay, the button follows the variant
  // data already on the page, and a short message offers a retry. Other product pages keep the theme's
  // own behaviour.
  const MESSAGE = 'We could not refresh the details for this option. Your choices are kept.';

  function sectionIdOf(picker) { return picker.dataset.originalSection || picker.dataset.section; }

  function clearMessage(picker) {
    const scope = picker.closest('[id^="MainProduct-"]') || picker.parentElement;
    scope?.querySelectorAll('[data-alac-variant-error]').forEach(node => node.remove());
  }

  function showMessage(picker, retry) {
    clearMessage(picker);
    const doc = picker.ownerDocument;
    const box = doc.createElement('p');
    box.className = 'alac-variant-error';
    box.dataset.alacVariantError = '';
    box.setAttribute('role', 'alert');
    box.append(MESSAGE + ' ');
    const button = doc.createElement('button');
    button.type = 'button';
    button.className = 'link';
    button.textContent = 'Try again';
    button.addEventListener('click', () => { clearMessage(picker); retry(); });
    box.append(button);
    picker.after(box);
    return box;
  }

  function swapById(doc, html, prefix, section, source) {
    const target = doc.getElementById(prefix + section);
    const from = html.getElementById(prefix + source);
    if (target && from) target.innerHTML = from.innerHTML;
  }

  async function render(picker, deps) {
    const requested = picker.currentVariant?.id;
    const sectionId = sectionIdOf(picker);
    const stale = () => !picker.isConnected || picker.currentVariant?.id !== requested;
    try {
      const response = await deps.fetch(picker.dataset.url + '?variant=' + requested + '&section_id=' + sectionId);
      if (!response.ok) throw new Error('Variant details returned ' + response.status);
      const text = await response.text();
      if (stale()) return 'stale';
      const html = new deps.DOMParser().parseFromString(text, 'text/html');
      const button = html.getElementById('ProductSubmitButton-' + sectionId);
      if (!button) throw new Error('Variant details are incomplete');
      const doc = picker.ownerDocument;
      ['price-', 'Sku-', 'Inventory-', 'Volume-', 'Price-Per-Item-'].forEach(prefix => swapById(doc, html, prefix, picker.dataset.section, sectionId));
      clearMessage(picker);
      picker.toggleAddButton(button.hasAttribute('disabled'), deps.soldOut());
      if (typeof deps.publish === 'function' && deps.events?.variantChange) {
        deps.publish(deps.events.variantChange, { data: { sectionId, html, variant: picker.currentVariant } });
      }
      return 'ok';
    } catch (error) {
      if (stale()) return 'stale';
      // Keep every selection; the button state comes from the variant data on the page.
      picker.toggleAddButton(!picker.currentVariant?.available, deps.soldOut());
      showMessage(picker, () => picker.renderProductInfo());
      deps.warn?.('Variant details could not load', error);
      return 'failed';
    }
  }

  function patch(Radios, deps) {
    const proto = Radios?.prototype;
    if (!proto || proto.alacVariantErrorPatched) return false;
    const original = proto.renderProductInfo;
    proto.renderProductInfo = function () {
      if (!this.closest?.('.alac-pdp')) return original.apply(this, arguments);
      return render(this, deps);
    };
    proto.alacVariantErrorPatched = true;
    return true;
  }

  const api = { patch, render, showMessage, clearMessage, MESSAGE };
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; return; }

  const deps = {
    fetch: (...args) => root.fetch(...args),
    DOMParser: root.DOMParser,
    soldOut: () => root.variantStrings?.soldOut || 'Sold out',
    publish: typeof publish === 'function' ? publish : null,
    events: typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : null,
    warn: (...args) => root.console?.warn(...args)
  };
  const apply = () => patch(root.customElements?.get('variant-radios'), deps);
  if (!apply()) root.customElements?.whenDefined?.('variant-radios').then(apply);
})(typeof window !== 'undefined' ? window : globalThis);
